export enum FintocStatusType {
    PaymentCreated = 'payment_created',
    PaymentError = 'payment_error',
    Closed = 'closed'
  }


// WEBPACK FOOTER //
// ./src/model/types/fintoc-status-type.ts